module.exports = __webpack_public_path__ + "static/media/file-big.13e836e5.svg";